/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';
import Pagination from 'components/atoms/pagination';
import Loader from 'components/atoms/loader';
import {
  getCompanyData,
  searchProviders,
  getProviderBiddings,
} from 'store/modules/market_store/actions';
import ProvidersModal from 'components/atoms/providers_modal';

interface ProvidersProps {
  params: any;
  selectedFilter: number | object[];
}

const Providers = (props: ProvidersProps) => {
  const { params, selectedFilter } = props;
  const dispatch = useDispatch();
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentPageBidding, setCurrentPageBidding] = useState<number>(1);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [cnpj, setCnpj] = useState<number>(0);

  const { concorrentes, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  const paginate = (currentPage = 1) => {
    if (currentPage) {
      setCurrentPage(currentPage);
    }
  };

  useEffect(() => {
    dispatch(searchProviders(params, currentPage));
    if (cnpj) dispatch(getProviderBiddings(cnpj, currentPageBidding));
  }, [params, currentPage, selectedFilter, currentPageBidding]);

  const setProvidersInfo = (selectedCnpj: number) => {
    dispatch(getCompanyData(selectedCnpj));
    // a listagem de itens vencidos recomeca na primeira pagina a cada concorrente aberto
    setCurrentPageBidding(1);
    setCnpj(selectedCnpj);
    dispatch(getProviderBiddings(selectedCnpj, 1));
    setShowModal(true);
  };
  return (
    <div className="card overflow-auto">
      <div>
        <div className="pl-2 my-2 d-flex align-items-center">
          <i className="material-icons">work</i>
          <b className="pl-1 mt-2">Concorrentes relacionados</b>
        </div>
      </div>
      <ul className="list-group list-group-flush table-responsive" style={{ maxHeight: '400px' }}>
        {request?.search_providers?.loading ? (
          <Loader />
        ) : (
          <table className="table">
            <thead style={{ backgroundColor: '#EBECEF' }}>
              <tr>
                <th scope="col">Razão social</th>
              </tr>
            </thead>
            <tbody>
              {concorrentes?.results?.map((concorrente, index) => (
                <tr onClick={() => setProvidersInfo(concorrente?.cnpj)} key={index}>
                  <td>{concorrente?.razao_social}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ul>
      <div className="border rounded-bottom border-top-0 d-print-none">
        <button
          type="button"
          key="btn-bidding-more-info"
          className="btn btn-sm btn-link m-0 w-100 mb-3"
          onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
        >
          {BiddingInfoToggle ? 'Ver menos' : 'Ver mais'}
        </button>
        {BiddingInfoToggle && (
          <div className="row d-print-none">
            <div className="col-md-12 px-4">
              <Pagination
                postsPerPage={10}
                totalPosts={concorrentes?.total}
                paginate={paginate}
                currentPage={currentPage}
                firstAndLastPage
              />
            </div>
          </div>
        )}
      </div>
      <ProvidersModal
        showModal={showModal}
        setShowModal={setShowModal}
        setCurrentPageBidding={setCurrentPageBidding}
        currentPageBidding={currentPageBidding}
      />
    </div>
  );
};

export default Providers;
